export interface CreateRegistrationBody {
  address: string;
  birth_date: string;
  cpf?: string;
  country_code: string;
  cupom: string;
  email: string;
  full_address: {
    city: string;
    city_ibge_code?: string;
    complement: string;
    neighborhood: string;
    number?: string;
    postal_code: string;
    state: string;
    street: string;
  };
  nome: string;
  telefone: string;
}

export interface CreateRegistrationRequest {
  courseId: number;
  body: CreateRegistrationBody;
}

export enum SubscriptionStatusCodes {
  Completed = 'completed',
  RegistrationStarted = 'registration_started',
  Pending = 'pending',
  Failed = 'failed',
  Paid = 'paid',
  Registered = 'registered',
  Canceled = 'canceled',
  Dropout = 'dropout',
  DuplicateRegistration = 'duplicate_registration',
  TestRegistration = 'test_registration',
  InvalidContact = 'invalid_contact',
  Registration = 'registration',
  DirectedIp = 'directed_ip',
}

export const SubscriptionStatusPendingCodes = new Set([
  SubscriptionStatusCodes.RegistrationStarted,
  SubscriptionStatusCodes.Pending,
  SubscriptionStatusCodes.Failed,
  SubscriptionStatusCodes.Paid,
  SubscriptionStatusCodes.Registration,
  SubscriptionStatusCodes.DirectedIp,
]);

export interface CreateRegistrationResponse {
  id: number;
}

export interface Subscription {
  subscription_id: number;
  offer_id: number;
  status: SubscriptionStatusCodes;
  subscribed_at: string;
}

export interface RegistrationShowResponse {
  subscriptions: Subscription[];
}
